import { useAuthStore } from "../../../zustand";

export const useIsAuthenticated = () => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const atk = useAuthStore((state) => state.atk);

  return isLoggedIn && atk !== null && atk.length > 0;
};
